import * as constants from '../constants/constants';
import { axiosCaller } from "../utils/apiCaller";
import {ACTION, setButtonLoading, setLoading, wrap} from './generalActions'

// --- Dashboard ---

export const fetchTransportDashboardStats = () => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `transport/dashboard-stats`).then(res => {
            dispatch({ "type": constants.FETCH_TRANSPORT_DASHBOARD_STATS, "payload": res.data.data });
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_TRANSPORT_DASHBOARD_STATS')

// --- CRUD ---

export const fetchTransports = (filters: any = {}) => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true));
        const params: string[] = [];

        if (filters.status) params.push(`status=${filters.status}`);
        if (filters.driver_id) params.push(`driver_id=${filters.driver_id}`);
        if (filters.search) params.push(`search=${encodeURIComponent(filters.search)}`);
        if (filters.start_date) params.push(`start_date=${filters.start_date}`);
        if (filters.end_date) params.push(`end_date=${filters.end_date}`);
        if (filters.page) params.push(`page=${filters.page}`);
        if (filters.per_page) params.push(`per_page=${filters.per_page}`);

        const url = `transport?${params.join('&')}`;

        return await axiosCaller('GET', url).then(res => {
            dispatch(setLoading(false));
            dispatch({ "type": constants.FETCH_TRANSPORTS, "payload": res.data });
            return res.data;
        })
    } catch(err) {
        dispatch(setLoading(false));
    }
}, 'FETCH_TRANSPORTS')

export const fetchTransport = (transportId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `transport/${transportId}`).then(res => {
            dispatch({ "type": constants.FETCH_TRANSPORT, "payload": res.data.data });
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_TRANSPORT')

export const createTransport = (payload: any) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('POST', `transport`, payload).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'CREATE_TRANSPORT')

export const updateTransport = (transportId: number, payload: any) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('PUT', `transport/${transportId}`, payload).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'UPDATE_TRANSPORT')

export const deleteTransport = (transportId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('DELETE', `transport/${transportId}`).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'DELETE_TRANSPORT')

export const updateTransportStatus = (transportId: number, status: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('PATCH', `transport/${transportId}/status`, { status }).then(res => {
            dispatch({ "type": constants.FETCH_TRANSPORT, "payload": res.data.data });
            return res.data;
        })
    } catch(err) {}
}, 'UPDATE_TRANSPORT_STATUS')

export const finishTransport = (transportId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('PATCH', `transport/${transportId}/finish`).then(res => {
            if (res.data.error) {
                return res.data; // { error: 'items_not_confirmed', confirmed: X, total: Y }
            }
            dispatch({ "type": constants.FETCH_TRANSPORT, "payload": res.data.data });
            return res.data;
        })
    } catch(err) {
        return err?.response?.data;
    }
}, 'FINISH_TRANSPORT')

// --- Items ---

export const fetchAvailableItems = (search = '', page = 1, perPage = 20) => wrap(async(dispatch:any) => {
    try {
        const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
        return await axiosCaller('GET', `transport/available-items?page=${page}&per_page=${perPage}${searchParam}`).then(res => {
            dispatch({ "type": constants.FETCH_AVAILABLE_TRANSPORT_ITEMS, "payload": res.data });
            return res.data;
        })
    } catch(err) {}
}, 'FETCH_AVAILABLE_ITEMS')

export const fetchWithoutTransport = (filters: any = {}) => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true));
        const params: string[] = [];
        if (filters.search) params.push(`search=${encodeURIComponent(filters.search)}`);
        if (filters.page) params.push(`page=${filters.page}`);
        if (filters.per_page) params.push(`per_page=${filters.per_page}`);

        return await axiosCaller('GET', `transport/without-transport?${params.join('&')}`).then(res => {
            dispatch(setLoading(false));
            dispatch({ "type": constants.FETCH_WITHOUT_TRANSPORT, "payload": res.data.data });
            return res.data.data;
        })
    } catch(err) { dispatch(setLoading(false)); }
}, 'FETCH_WITHOUT_TRANSPORT')

export const createWithoutTransport = (payload: any) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('POST', `transport/without-transport`, payload).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'CREATE_WITHOUT_TRANSPORT')

export const addTransportItems = (transportId: number, warehouseRecordIds: number[], itemAddresses?: string[], itemCoordinates?: string[]) => wrap(async(dispatch:any) => {
    try {
        const payload: any = { warehouse_record_ids: warehouseRecordIds };
        if (itemAddresses) payload.item_addresses = itemAddresses;
        if (itemCoordinates) payload.item_coordinates = itemCoordinates;

        return await axiosCaller('POST', `transport/${transportId}/items`, payload).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'ADD_TRANSPORT_ITEMS')

export const removeTransportItem = (transportId: number, itemId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('DELETE', `transport/${transportId}/items/${itemId}`).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'REMOVE_TRANSPORT_ITEM')

export const confirmItemDelivery = (transportId: number, itemId: number, deliveryNotes?: string) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('PATCH', `transport/${transportId}/items/${itemId}/confirm`, {
            delivery_notes: deliveryNotes || null
        }).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'CONFIRM_ITEM_DELIVERY')

// --- Checklist ---

export const addChecklistItem = (transportId: number, label: string) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('POST', `transport/${transportId}/checklist`, { label }).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'ADD_CHECKLIST_ITEM')

export const toggleChecklistItem = (transportId: number, itemId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('PATCH', `transport/${transportId}/checklist/${itemId}`).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'TOGGLE_CHECKLIST_ITEM')

export const removeChecklistItem = (transportId: number, itemId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('DELETE', `transport/${transportId}/checklist/${itemId}`).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'REMOVE_CHECKLIST_ITEM')

// --- Comments ---

export const addTransportComment = (transportId: number, text: string) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('POST', `transport/${transportId}/comments`, { text }).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'ADD_TRANSPORT_COMMENT')

// --- Helpers ---

export const fetchTransportDrivers = () => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `transport/drivers`).then(res => {
            dispatch({ "type": constants.FETCH_TRANSPORT_DRIVERS, "payload": res.data.data });
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_TRANSPORT_DRIVERS')

export const fetchTransportLocations = (filters: any = {}) => wrap(async(dispatch:any) => {
    try {
        const params: string[] = [];
        if (filters.status) params.push(`status=${filters.status}`);
        const url = `transport/locations${params.length ? '?' + params.join('&') : ''}`;

        return await axiosCaller('GET', url).then(res => {
            dispatch({ "type": constants.FETCH_TRANSPORT_LOCATIONS, "payload": res.data.data });
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_TRANSPORT_LOCATIONS')

export const fetchTransportTimeline = (transportId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `transport/${transportId}/timeline`).then(res => {
            dispatch({ "type": constants.FETCH_TRANSPORT_TIMELINE, "payload": res.data.data });
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_TRANSPORT_TIMELINE')

// --- Legacy (kept for backward compat) ---

export const fetchEquipments = () => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `mounting-equipments`).then(res => {
            dispatch({ "type": constants.FETCH_EQUIPMENTS, "payload": res.data.data });
        })
    } catch(err) {}
}, 'FETCH_EQUIPMENTS')

export const setSelectedWarehouseRecordForTransport = (payload: any): ACTION => ({
    type: constants.SET_SELECTED_WAREHOUSE_RECORD_FOR_TRANSPORT,
    payload
});
